const metaKeywords = {
  ru: {
    homePage: "",
    aeroflotInfo:
      "Аэрофлот, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet narxlari toshkent, moskva aviabilet narxlari, купить авиабилеты, авиабилеты Аэрофлот",
    uzairways:
      "aviabilet, авиабилет, Uzbekistan Airways, авиабилеты Ташкент, рейсы Узбекистан, купить билет на самолет, авиаперелеты",
    turkishInfo:
      "aviabilet, авиабилет, Turkish Airlines, авиабилеты Ташкент, рейсы Turkish Airlines, авиабилеты Стамбул, купить авиабилет дешево",
    belaviaInfo:
      "Belavia, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    uralairlinesInfo:
      "aviabilet, авиабилет, Ural Airlines, авиабилеты Ташкент, рейсы Ural Airlines, авиабилеты Москва, купить авиабилет дешево",
    s7Info:
      "viabilet, авиабилет, S7 Airlines, авиабилеты Ташкент, рейсы S7, авиабилеты Москва, купить авиабилет дешево",
    qanotsharqInfo:
      "qanot sharq, авиабилеты, авиабилеты ташкент, дешёвые авиабилеты, билеты узбекистан, билеты москва ташкент, qanot sharq расписание",
    pobedaInfo:
      "pobeda, авиабилеты, авиабилеты ташкент, дешёвые авиабилеты, билеты узбекистан, билеты москва ташкент, pobeda расписание",
    airastanaInfo:
      "Air Astana, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    flyaristanInfo:
      "FlyArystan, авиакомпания Казахстан, лоукост, рейсы Ташкент–Алматы, дешёвые билеты, авиаперелёты в Центральной Азии, Airbus A320",
    aircairoInfo:
      "Air Cairo, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    airchinaInfo:
      "Air China, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    airmanasInfo:
      "Air Manas, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    asianaAirlinesInfo:
      "Asiana Airlines, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    aviaTrafficInfo:
      "Avia Traffic Company, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    azalInfo:
      "AZAL, Azerbaijan Airlines, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    azimuthInfo:
      "Azimuth, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    azurairInfo:
      "Azur Air, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    spicejetInfo:
      "aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet hindiston, aviabilet delhi, spicejet uzbekistan, spicejet aviabilet, arzon aviabilet, авиабилеты Индия, авиабилеты Ташкент Дели",
    irAeroInfo: "iraero, авиабилеты узбекистан россия, чартер ташкент иркутск, irkutsk flights, авиарейсы в сибирь",
    auroraAirlinesInfo: "Aurora Airlines, Аврора, региональные рейсы, Дальний Восток, Сибирь, авиакомпания Россия",
    yamalAirlinesInfo: "Yamal Airlines, авиабилеты, Ямало-Ненецкий округ, Airbus A320, Sukhoi Superjet 100",
    yakutiaAirlinesInfo: "Якутия Airlines, авиакомпания Якутия, флот, Boeing 737, Sukhoi Superjet 100",
    rossiyaAirlinesInfo:
      "Rossiya Airlines, aviabilet, aviabilet narxlari, авиабилеты дешевые, aviabilet moskva, aviabilet narxlari toshkent, moskva aviabilet narxlari, купить авиабилеты, авиабилеты Rossiya Airlines",
    nordwindAirInfo:
      "Nordwind Airlines, чартерные авиарейсы, рейсы Ташкент-Анталия, Ташкент-Бодрум, авиапарк, Airbus A321, Boeing 737-800, купить авиабилет, чартеры Узбекистан",
    lufthansaAirInfo:
      "Lufthansa, авиабилеты, Франкфурт, Ташкент–Германия, рейсы Lufthansa, купить билет Lufthansa, Airbus A350, Boeing 747-8",
    silkAirInfo:
      "SilkAir, Singapore Airlines, рейсы Сингапур, авиакомпания SilkAir, Boeing 737, пересадки через Сингапур, история SilkAir",
    tajikAirInfo:
      "Tajik Air, Таджикистан, рейсы Душанбе, авиарейсы в Узбекистан, авиакомпания Таджикистана, Boeing 737, старейшая авиакомпания, таджикская авиация",
    somonAirInfo:
      "Somon Air, рейсы Душанбе, авиабилеты Таджикистан, чартеры, Boeing 737-800, Tashkent–Dushanbe, авиакомпания Таджикистана",
    kamairInfo:
      "Kam Air, авиакомпания Афганистана, рейсы Кабул, авиабилеты, чартеры, Airbus A340, Boeing 737, Ташкент–Кабул",
    ilkarAirInfo:
      "Ilkar Air, чартерные рейсы, Ташкент–Анталия, Ташкент–Баку, Embraer E190, Boeing 737, авиакомпания Турция",
    flydubaiAirInfo:
      "flydubai, авиабилеты в Дубай, рейсы Ташкент–Дубай, Emirates, Boeing 737 MAX, бюджетные авиаперелёты, авиакомпания ОАЭ",
    kuwaitAirwaysInfo:
      "Kuwait Airways, рейсы Кувейт, Ташкент–Кувейт, авиабилеты, Airbus A330neo, Boeing 777, авиакомпания Персидского залива",
    emiratesAirInfo:
      "Emirates, авиабилеты, рейсы Ташкент–Дубай, Airbus A380, Boeing 777, премиум авиакомпания, ОАЭ, международные перелёты",
    centrumAirInfo:
      "Centrum Air, Узбекистан, дешевые авиабилеты, Ташкент, Airbus A320, внутриреспубликанские рейсы, авиакомпания Узбекистана, лоукостер",
    egyptAirInfo:
      "EgyptAir, рейсы Ташкент–Каир, авиакомпания Египта, Star Alliance, Airbus A320, Boeing 787, авиабилеты в Египет",
    chinaSouthernInfo:
      "China Southern Airlines, рейсы Ташкент–Гуанчжоу, авиакомпания Китая, Airbus A350, Boeing 777, китайские авиалинии, авиабилеты",
    piaInfo:
      "PIA, Pakistan International Airlines, авиабилеты Ташкент–Исламабад, Boeing 777, Airbus A320, чартерные рейсы Пакистан, авиакомпания Пакистана",
    airblueInfo:
      "Airblue, авиакомпания Пакистан, рейсы Ташкент–Исламабад, Airbus A320, Airbus A321, авиабилеты Пакистан, частный перевозчик",
    sereneAirInfo:
      "SereneAir, авиакомпания Пакистана, Boeing 737, Airbus A330, рейсы Ташкент–Исламабад, чартеры, частный перевозчик",
    airIndiaInfo:
      "Air India, авиакомпания Индии, рейсы Ташкент–Дели, Boeing 787, Airbus A320, Tata Group, прямые рейсы в Индию",
    vistaraInfo:
      "Vistara, авиакомпания Индии, рейсы через Дели, Airbus A320neo, Boeing 787 Dreamliner, Tata Group, Singapore Airlines, авиабилеты Индия",
    gulfAirInfo:
      "Gulf Air, авиакомпания Бахрейн, Boeing 787, Airbus A320neo, рейсы Ташкент–Манама, ближневосточный перевозчик, стыковки",
    omanAirInfo:
      "Oman Air, авиакомпания Оман, Ташкент–Маскат, Boeing 737, Boeing 787, авиабилеты в Оман, ближневосточные авиалинии",
    salamAirInfo:
      "SalamAir, авиакомпания Оман, Ташкент–Маскат, Самарканд–Маскат, лоукост авиабилеты, Airbus A320, бюджетные рейсы, чартеры Узбекистан",
    iranAsemanAirlinesInfo:
      "Iran Aseman Airlines, иранские авиалинии, рейсы в Иран, Тегеран–Ташкент, региональные самолёты, чартеры Узбекистан, авиакомпания Ирана",
    kishAirInfo:
      "Kish Air, авиакомпания Иран, остров Киш, внутренние рейсы, MD-82, Fokker 100, Airbus A321, Тегеран–Киш, чартеры",
    qeshmAirInfo:
      "Qeshm Air, авиакомпания Иран, Тегеран–Кешм, внутренние рейсы, Airbus A300, Fokker 100, чартерные рейсы, региональный перевозчик",
    syrianAirInfo:
      "SyrianAir, авиакомпания Сирия, рейсы Дамаск, Airbus A320, ближневосточные авиалинии, национальный перевозчик Сирии, авиабилеты",
    middleEastAirlinesInfo:
      "Middle East Airlines, MEA, авиакомпания Ливан, рейсы Бейрут, Airbus A320neo, A330, авиабилеты SkyTeam, рейсы из Ташкента",
    aircompanyArmeniaInfo:
      "Aircompany Armenia, армянская авиакомпания, рейсы в Ереван, Boeing 737-500, авиабилеты Армения, перелёты из Узбекистана",
    arianaAfghanAirlinesInfo:
      "Ariana Afghan Airlines, авиакомпания Афганистан, Кабул, рейсы в Азию, Boeing 737-400, Airbus A310, авиабилеты, афганские авиалинии",
    georgianAirwaysInfo:
      "Georgian Airways, авиакомпания Грузия, рейсы Тбилиси, Ташкент–Тбилиси, Embraer 190, Boeing 737, авиабилеты в Грузию",
    myWayAirlinesInfo:
      "MyWay Airlines, грузинская авиакомпания, рейсы Тбилиси, Ташкент, Самарканд, Boeing 737-800, чартеры, СНГ, авиабилеты",
    koreanAirInfo:
      "Korean Air, Сеул авиабилеты, рейсы в Корею, Ташкент–Сеул, Airbus A380, Boeing 777, SkyTeam, премиум авиакомпания, Корея",
    jazeeraAirwaysInfo:
      "Jazeera Airways, авиакомпания Кувейт, рейсы Ташкент–Кувейт, бюджетные авиабилеты, A320neo, авиарейсы Персидский залив, Jazeera Uzbekistan",
    mahanAirInfo:
      "Mahan Air, авиакомпания Иран, рейсы в Тегеран, Airbus A310, A300, A340, BAe 146, международные рейсы, авиабилеты Ташкент",
    indigoAirlinesInfo:
      "IndiGo Airlines, авиакомпания Индия, рейсы Ташкент–Дели, A320neo, бюджетные авиабилеты, индийские маршруты, авиаперевозчик Индии",
    alrosaAirlinesInfo:
      "Alrosa Airlines, авиакомпания Якутия, рейсы Сибирь, Ту-154, Ан-24, Boeing 737, чартерные рейсы, авиаперевозки Якутск",
    turkmenistanAirlinesInfo:
      "Turkmenistan Airlines, авиакомпания Туркменистан, рейсы Ташкент–Ашхабад, Boeing 737, Boeing 777, центральноазиатские авиалинии",
    saudiaAirlinesInfo:
      "Saudia Airlines, Saudi Arabian Airlines, Ташкент–Джидда, хадж, умра, авиабилеты в Саудовскую Аравию, рейсы Джидда, Эр-Рияд, Airbus A330, Boeing 777",
    pegasusAirInfo:
      "Pegasus Airlines, aviabilet, aviabilet narxlari, бюджетные авиабилеты, Uzbekistan–Istanbul, Sabiha Gökçen, Airbus A320-200, Airbus A320neo, Airbus A321neo, Boeing 737-800, купить авиабилеты, лоукостер Турция",
  },
  uz: {
    homePage: "",
    aeroflotInfo:
      "Аэрофлот, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet narxlari toshkent, moskva aviabilet narxlari, купить авиабилеты, авиабилеты Аэрофлот",
    uzairways:
      "aviabilet, авиабилет, Uzbekistan Airways, авиабилеты Ташкент, рейсы Узбекистан, купить билет на самолет, авиаперелеты",
    turkishInfo:
      "aviabilet, aviabilet narxlari, Turkish Airlines, aviabilet Toshkent, samolyot chiptalari, havo yo‘nalishlari",
    belaviaInfo:
      "Belavia, Belarus aviakompaniyasi, Embraer, Boeing 737, Toshkent–Minsk, Yevropa reyslari, MDH yo‘nalishlari, aviabiletlar",
    uralairlinesInfo:
      "aviabilet, aviabilet narxlari, Ural Airlines, ural, aviabilet Toshkent, samolyot chiptalari, havo yo‘nalishlari",
    s7Info: "aviabilet, aviabilet narxlari, S7 Airlines, aviabilet Toshkent, samolyot chiptalari, havo yo‘nalishlari",
    qanotsharqInfo:
      "qanot sharq, aviabilet, aviabilet narxlari, aviabilet tashkent, aviabilet moskva, aviabilet sankt peterburg, qanot sharq reyslari",
    pobedaInfo:
      "pobeda, aviabilet, aviabilet narxlari, aviabilet tashkent, aviabilet moskva, aviabilet sankt peterburg, pobeda reyslari",
    airastanaInfo:
      "Air Astana, Qozog‘iston aviakompaniyasi, Toshkent–Olmaota reyslari, Airbus A321, Embraer E2, Yevropa yo‘nalishlari, parvozlar O‘zbekistondan",
    flyaristanInfo:
      "FlyArystan, arzon aviakompaniya, Qozog‘iston reyslari, Airbus A320, Toshkent–Olmaota, Samarqand–Astana, markaziy osiyo parvozi",
    aircairoInfo:
      "Air Cairo Toshkent va Samarqanddan Qohira va Sharm el-Shayxga parvozlarni taklif etadi. Chipta va narxlar biletbor.me saytida.",
    airchinaInfo:
      "Air China, Xitoy aviakompaniyasi, Toshkent–Pekin, A330, A350, Boeing 777, Pekin reyslari, Osiyo, Star Alliance, arzon aviachiptalar",
    airmanasInfo:
      "Air Manas, Qirg‘iziston aviakompaniyasi, Toshkent–Bishkek reyslari, Pegasus Asia, arzon parvozlar, airmanas.com, charter reyslar",
    asianaAirlinesInfo: "Asiana Airlines, aviabilet, Toshkent–Seul, Incheon, Airbus, Boeing",
    aviaTrafficInfo:
      "Avia Traffic Company, Qirg‘iziston reyslari, Toshkent–Bishkek, O‘sh reyslari, Moskvaga parvozlar, Boeing 737, arzon aviachiptalar",
    azalInfo:
      "AZAL, Azerbaijan Airlines, Toshkent–Boku, Ozarbayjon aviakompaniyasi, Airbus A320, Dreamliner, Kavkaz reyslari, GYD aeroporti",
    azimuthInfo:
      "Azimuth Airlines, Superjet 100, Toshkent–Sochi, Samarqand–Rostov, arzon reyslar, janubiy Rossiyaga charter reyslar",
    azurairInfo:
      "Azur Air, charter reyslar, Toshkent–Antaliya, Sharm-ash-Shayx, Xurgada, Boeing 767, arzon sayohat, O‘zbekiston–Rossiya parvozi",
    spicejetInfo:
      "cheap flights, cheap tickets, SpiceJet Uzbekistan, SpiceJet Tashkent Delhi, flights to India, budget airline India, Tashkent to Delhi flights, affordable airfare, book flights online",
    irAeroInfo:
      "IrAero, Rossiya aviakompaniyasi, Tashkentdan parvozlar, Irkutsk, Superjet 100, A319, charter reyslar, O‘zbekiston–Rossiya",
    auroraAirlinesInfo: "Aurora Airlines, mintaqaviy parvozlar, Rossiya, Dallar Osiyo, Sibiri, aviakompaniya",
    yamalAirlinesInfo: "Yamal Airlines, parvozlar, Salyekhard, Airbus A320, Sukhoi Superjet 100",
    yakutiaAirlinesInfo:
      "Yakutia Airlines, aviakompaniya Yakutiya, aviabilet, aviabilet narxlari, Boeing 737-700, Boeing 737-800, Sukhoi Superjet 100, Dash 8 Q300, MC-21-300, stykovkalar Moskva, stykovkalar Novosibirsk",
    rossiyaAirlinesInfo:
      "Rossiya Airlines, aviabilet, aviabilet narxlari, arzon aviabiletlar, aviabilet Moskva, aviabilet narxlari Toshkent, Rossiya Airlines aviabiletlari, flot, bagaj",
    nordwindAirInfo:
      "Nordwind Airlines, charter reyslar, Toshkent–Antaliya, Toshkent–Bodrum, samolyot floti, aviabilet narxlari, Boeing 737, Airbus A330, parvozlar, arzon aviachipta",
    lufthansaAirInfo:
      "Lufthansa, Frankfurt, aviabilet narxlari, Toshkent–Yevropa, Lufthansa parvozi, Airbus A350, Boeing 747, Yevropaga parvozlar",
    silkAirInfo:
      "SilkAir, Singapore Airlines, Boeing 737, Changi, Singapurga parvozlar, aviakompaniya tarixi, SilkAir yo‘nalishlari",
    tajikAirInfo:
      "Tajik Air, Dushanbe reyslari, Tojikiston aviakompaniyasi, O‘zbekiston parvozlari, Boeing 737, An-26, aviabilet narxlari, Tojikiston transporti",
    somonAirInfo:
      "Somon Air, Toshkent–Dushanbe, aviabilet narxlari, Boeing 737-800, Boeing 737-900, Tojikiston aviakompaniyasi, charter reyslar",
    kamairInfo:
      "Kam Air, Kobul parvozi, aviabiletlar, Airbus A340, Boeing 737, Afg‘oniston aviakompaniyasi, charter reyslar, O‘zbekiston–Kobul",
    ilkarAirInfo:
      "Ilkar Air, Toshkent–Antaliya, Toshkent–Boku, charter reyslar, Turkiya aviakompaniyasi, Boeing 737-700, Embraer E190",
    flydubaiAirInfo:
      "flydubai, Dubay reyslari, Toshkent–Dubay, arzon aviachiptalar, Boeing 737 MAX, Emirates, BAA aviakompaniyasi",
    kuwaitAirwaysInfo:
      "Kuwait Airways, Kuvayt reyslari, Toshkent–Kuvayt, Boeing 777, Airbus A330neo, aviakompaniya, Yaqin Sharq parvozlari",
    emiratesAirInfo:
      "Emirates, Dubay parvozi, Toshkent–Dubay, Airbus A380, Boeing 777, premium xizmat, BAA aviakompaniyasi, xalqaro reyslar",
    centrumAirInfo:
      "Centrum Air, arzon reyslar, Toshkent–Nukus, Airbus A320, O‘zbekiston loukosteri, aviachipta narxlari, ichki parvozlar",
    egyptAirInfo:
      "EgyptAir, Toshkent–Qohira, Egypt Air reyslari, Star Alliance, Boeing 787, Airbus A320, Misr aviakompaniyasi",
    chinaSouthernInfo:
      "China Southern Airlines, Xitoyga reyslar, Toshkent–Guanchjou, Airbus A350, Boeing 777, Xitoy aviakompaniyasi, tranzit parvozlar",
    piaInfo:
      "PIA, Pokiston reyslari, Toshkent–Islomobod, Boeing 777, Airbus A320, aviakompaniya Pokiston, charter reyslar, xalqaro yo‘nalishlar",
    airblueInfo:
      "Airblue, Toshkent–Islomobod reyslari, Airbus A320, Airbus A321, Pokiston aviakompaniyasi, aviachipta narxlari, xususiy tashuvchi",
    sereneAirInfo:
      "SereneAir, Boeing 737, Airbus A330, Pokiston reyslari, Toshkent–Islomobod, charter reyslar, yangi aviakompaniya",
    airIndiaInfo:
      "Air India, Toshkent–Deli reyslari, Hindiston aviakompaniyasi, Boeing 787, Airbus A320, Tata Group, xalqaro yo‘nalishlar",
    vistaraInfo:
      "Vistara, Hindiston reyslari, Airbus A320neo, Boeing 787, Tata Group, Singapore Airlines, Deli orqali ulanish, parvozlar O‘zbekiston",
    gulfAirInfo:
      "Gulf Air, Bahrayn aviakompaniyasi, Tashkent–Manama reyslari, Boeing 787, Airbus A320neo, xalqaro parvozlar, Yaqin Sharq",
    omanAirInfo:
      "Oman Air, Ummon aviakompaniyasi, Toshkent–Masqat, Boeing 737, Boeing 787, Yaqin Sharq reyslari, aviabilet narxlari",
    salamAirInfo:
      "SalamAir, Masqat reyslari, Toshkent–Masqat, Samarqand reyslari, arzon aviabiletlar, A320neo, A321neo, Ummon loukoster",
    iranAsemanAirlinesInfo:
      "Iran Aseman Airlines, Eron reyslari, Fokker 100, Tehron–Toshkent, ATR samolyotlari, hududiy aviakompaniya, Eron aviabiletlar",
    kishAirInfo:
      "Kish Air, Eron aviakompaniyasi, orol Kesh, ichki reyslar, MD-83, Fokker 100, Airbus A321, turistik yo‘nalishlar, Tehron–Kesh",
    qeshmAirInfo:
      "Qeshm Air, Eron aviakompaniyasi, Airbus A300, Fokker 100, RJ-85, Tehron reyslari, ichki qatnovlar, Keshm oroli",
    syrianAirInfo:
      "SyrianAir, Suriya reyslari, Damashq, Airbus A320, Tu-134, Yak-40, Yaqin Sharq aviakompaniyasi, aviabiletlar",
    middleEastAirlinesInfo:
      "Middle East Airlines, MEA, Livan aviakompaniyasi, Airbus A320, A330, SkyTeam, Beirut reyslari, O‘zbekiston ulanishlari",
    aircompanyArmeniaInfo:
      "Aircompany Armenia, Armaniston reyslari, Yerevan reyslari, Boeing 737-500, Armaniston aviakompaniyasi, xalqaro yo‘nalishlar",
    arianaAfghanAirlinesInfo:
      "Ariana Afghan Airlines, Afg‘oniston aviakompaniyasi, Kobul reyslari, Boeing 737, Airbus A310, mintaqaviy yo‘nalishlar, arzon parvozlar",
    georgianAirwaysInfo:
      "Georgian Airways, Gruziya aviakompaniyasi, Tbilisi reyslari, Toshkent–Tbilisi, Embraer 190, Boeing 737, O‘zbekiston–Gruziya",
    myWayAirlinesInfo:
      "MyWay Airlines, Gruziya aviakompaniyasi, Tbilisi reyslari, Boeing 737-800, Toshkent, Samarqand, arzon parvozlar, charter reyslar",
    koreanAirInfo:
      "Korean Air, Seul reyslari, Toshkent–Seul, Airbus A380, Boeing 777, SkyTeam, Koreya aviakompaniyasi, xalqaro yo‘nalishlar",
    jazeeraAirwaysInfo:
      "Jazeera Airways, Kuvayt reyslari, Toshkent–Kuvayt, A320neo, arzon parvozlar, Yaqin Sharq, Jazeera Uzbekistan",
    mahanAirInfo:
      "Mahan Air, Tehron reyslari, Airbus A310, A340, BAe 146, Eron aviakompaniyasi, Toshkent–Tehron, xalqaro qatnovlar",
    indigoAirlinesInfo:
      "IndiGo Airlines, Hindiston reyslari, Toshkent–Dehli, A320neo, arzon aviachiptalar, ichki parvozlar, Hindiston aviakompaniyasi",
    alrosaAirlinesInfo:
      "Alrosa Airlines, Yaqutiya aviakompaniyasi, Tu-154M, Boeing 737, An-24, charter reyslar, Rossiya shimoli, aviauloqalar",
    turkmenistanAirlinesInfo:
      "Turkmenistan Airlines, Turkmaniston aviakompaniyasi, Tashkent–Ashxobod reyslari, Boeing 737, Boeing 777, xalqaro yo‘nalishlar",
    saudiaAirlinesInfo:
      "Saudia Airlines, Saudiya Arabistoni reyslari, Toshkent–Jidda, haj parvozlari, Airbus A330, Boeing 777, SkyTeam, aviakompaniya Saudiya",
    pegasusAirInfo:
      "Pegasus Airlines, aviabilet, aviabilet narxlari, byudjet parvozlar, Toshkent–Istanbul, Sabiha Gökçen, Airbus A320-200, Airbus A320neo, Airbus A321neo, Boeing 737-800, byudjet aviakompaniya, Turkiya",
  },
  en: {
    homePage: "",
    aeroflotInfo:
      "Аэрофлот, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet narxlari toshkent, moskva aviabilet narxlari, купить авиабилеты, авиабилеты Аэрофлот",
    uzairwaysInfo:
      "UzAirways, Uzbekistan Airways, flights from Tashkent, Uzbekistan airline, Dreamliner, uzairways.com, international routes from Uzbekistan",
    turkishInfo:
      "turkish airlines, uzbekistan to europe, tashkent istanbul, flights turkey uzbekistan, international airline",
    belaviaInfo:
      "Belavia, Belarus airline, Tashkent–Minsk flights, Embraer E195, Boeing 737, Eastern Europe routes, CIS flights, Belavia Uzbekistan",
    uralairlinesInfo:
      "Ural Airlines, flights Uzbekistan–Russia, Tashkent–Moscow, Samarkand–Yekaterinburg, Airbus A320, budget airline Russia, uralairlines",
    s7Info:
      "S7 Airlines, Uzbekistan to Russia flights, Tashkent–Novosibirsk, Airbus A320neo, Boeing 737, s7.ru, Oneworld airline, Russian carrier",
    qanotsharqInfo:
      "Qanot Sharq Airlines, Uzbekistan airline, Tashkent–Istanbul, budget flights Uzbekistan, Airbus A320, qanotsharq.com, Central Asia flights",
    pobedaInfo: "Pobeda Airlines, low-cost flights, Tashkent to Moscow, budget airline Russia, biletbor",
    airastanaInfo:
      "Air Astana, Kazakhstan airline, Tashkent–Almaty flights, Airbus A321LR, Embraer E190, Central Asia flights, flights from Uzbekistan",
    flyaristanInfo:
      "FlyArystan, low-cost airline Kazakhstan, Tashkent–Almaty, Airbus A320, budget flights Central Asia, FlyArystan Uzbekistan",
    aircairoInfo:
      "Fly from Tashkent and Samarkand to Cairo and Sharm El-Sheikh with Air Cairo. Book now via biletbor.me.",
    airchinaInfo:
      "Air China, Chinese airline, Tashkent–Beijing flights, Star Alliance, Airbus A350, Boeing 787, Asia travel, Uzbekistan to China",
    airmanasInfo:
      "Air Manas, Kyrgyz airline, flights from Bishkek to Tashkent, Pegasus Asia, Boeing 737 Kyrgyzstan, airmanas.com, cheap regional flights",
    asianaAirlinesInfo: "Asiana Airlines, flights, Tashkent–Seoul, Incheon, Airbus, Boeing",
    aviaTrafficInfo:
      "Avia Traffic Company, Tashkent–Bishkek flights, Osh routes, charter flights to Moscow, Boeing 737, low-cost Central Asia airline",
    azalInfo:
      "AZAL, Azerbaijan Airlines, Tashkent–Baku flights, Airbus A320, Boeing Dreamliner, Azerbaijan national carrier, flights from Uzbekistan",
    azimuthInfo:
      "Azimuth Airlines, Sukhoi Superjet, flights from Tashkent, Uzbekistan–Russia routes, regional Russian flights, budget airline",
    azurairInfo:
      "Azur Air, charter airline Russia, Uzbekistan–Antalya, Hurghada flights, Boeing 767, Sharm El Sheikh, leisure travel charter airline",
    spicejetInfo:
      "aviabilet, aviabilet narxlari, aviabilet arzon, aviabilet hindiston, spicejet uzbekistan, spicejet toshkent delhi, hindiston aviabilet, arzon aviachipta, Dehli reyslari",
    iraeroInfo:
      "Iraero, airline ticket, flight ticket prices, cheap tickets, flights to Moscow, flights to Irkutsk, flights to Yakutsk",
    auroraAirlinesInfo: "Aurora Airlines, regional flights, Russian Far East, Siberia, Airbus A319, Bombardier Q400",
    yamalAirlinesInfo: "Yamal Airlines, regional flights, Salekhard, Airbus A320, Sukhoi Superjet 100",
    yakutiaAirlinesInfo:
      "Yakutia Airlines, airline tickets, fare prices, Boeing 737-700, Boeing 737-800, Sukhoi Superjet 100, Dash 8 Q300, MC-21-300, connections Moscow, connections Novosibirsk, Yakutsk Airport",
    rossiyaAirlinesInfo:
      "Rossiya Airlines, airline tickets, fare prices, cheap tickets, Tashkent flights, Moscow flights, fleet, baggage, booking",
    nordwindAirInfo:
      "Nordwind Airlines, charter flights, Uzbekistan–Antalya, Uzbekistan–Bodrum, Airbus A321, Boeing 737-800, long-haul jets, tourist airline Russia",
    lufthansaAirInfo:
      "Lufthansa, flights from Uzbekistan, Tashkent–Frankfurt, Star Alliance, Airbus A350, Boeing 747-8, international routes, European destinations",
    silkAirInfo:
      "SilkAir, Singapore Airlines, Boeing 737 MAX 8, regional flights, Southeast Asia airline, Changi connections, SilkAir history",
    tajikAirInfo:
      "Tajik Air, Dushanbe flights, Uzbekistan routes, Central Asia airlines, Boeing 737, Yak-40, cargo flights, regional air carrier",
    somonAirInfo:
      "Somon Air, Tajikistan airline, Tashkent–Dushanbe flights, Boeing 737-800, regional air carrier, Central Asia airline, charter flights",
    kamairInfo:
      "Kam Air, Kabul flights, Tashkent–Kabul, Afghanistan airline, Airbus A340, Boeing 737, Central Asia aviation, charter carrier",
    ilkarAirInfo:
      "Ilkar Air, charter flights, Tashkent–Antalya, Tashkent–Baku, Turkish airline, Boeing 737-700, Embraer E190, regional air travel",
    flydubaiAirInfo:
      "flydubai, cheap flights, Tashkent–Dubai, UAE airline, Boeing 737 MAX 8, Emirates partner, direct flights Uzbekistan",
    kuwaitAirwaysInfo:
      "Kuwait Airways – national carrier of Kuwait. Flights from Uzbekistan, modern Airbus and Boeing fleet, and international routes.",
    emiratesAirInfo:
      "Emirates, Tashkent–Dubai flights, Airbus A380, Boeing 777, UAE airline, premium service, international routes, Dubai airport",
    centrumAirInfo:
      "Centrum Air, low-cost Uzbekistan airline, Tashkent–Samarkand, Nukus flights, Airbus A320, budget tickets, regional travel",
    egyptAirInfo:
      "EgyptAir, Tashkent to Cairo, Star Alliance airline, Airbus A220, Boeing 787, North Africa airline, flights from Uzbekistan",
    chinaSouthernInfo:
      "China Southern Airlines, Tashkent–Guangzhou flights, Chinese airline, Boeing 777, Airbus A350, flights from Uzbekistan, China routes",
    piaInfo:
      "PIA, Pakistan International Airlines, Tashkent flights, Boeing 777, Airbus A320, Islamabad, Lahore, Karachi, charter flights",
    airblueInfo:
      "Airblue, Pakistan airline, Tashkent–Islamabad, private carrier, Airbus A320, affordable flights, UAE transit, digital aviation",
    sereneAirInfo:
      "SereneAir, Pakistani airline, Boeing 737, Airbus A330, Tashkent flights, Islamabad route, charter services, private carrier",
    airIndiaInfo:
      "Air India, Tashkent–Delhi flights, Boeing 787 Dreamliner, Airbus A320, Tata Group airline, India carrier, long-haul travel",
    vistaraInfo:
      "Vistara, Tata Group airline, Singapore Airlines, Airbus A320neo, Boeing 787 Dreamliner, premium Indian flights, Delhi hub",
    gulfAirInfo:
      "Gulf Air, Bahrain airline, Tashkent–Manama flights, Boeing 787 Dreamliner, Airbus A320neo, Middle East airline, Gulf carrier",
    omanAirInfo:
      "Oman Air, Oman airline, Tashkent–Muscat flights, Boeing 787 Dreamliner, Middle East aviation, Gulf carrier, premium service",
    salamAirInfo:
      "SalamAir, Tashkent–Muscat flights, Samarkand–Muscat, budget airline Oman, A320neo, A321neo, charter flights, Gulf low-cost airline",
    iranAsemanAirlinesInfo:
      "Iran Aseman Airlines, ATR 72, Fokker 100, regional Iran flights, Tehran–Tashkent connections, domestic Iranian airline",
    kishAirInfo:
      "Kish Air, Iranian airline, Kish Island flights, Tehran–Kish, MD-83, Fokker 100, domestic flights Iran, tourism travel",
    qeshmAirInfo:
      "Qeshm Air, Iran airline, Qeshm Island flights, Airbus A300, Fokker 100, RJ-85, Tehran routes, domestic aviation Iran",
    syrianAirInfo:
      "SyrianAir, Syrian airline, Damascus flights, Airbus A320, Tu-134, Yak-40, Middle East carrier, Syria national airline",
    middleEastAirlinesInfo:
      "Middle East Airlines, MEA, Beirut flights, A320neo, A330, SkyTeam, Middle East routes, Uzbekistan to Lebanon, premium service",
    aircompanyArmeniaInfo:
      "Aircompany Armenia, Armenia airline, Yerevan flights, Boeing 737-500, Armenia travel, regional air connections, flights from Uzbekistan",
    arianaAfghanAirlinesInfo:
      "Ariana Afghan Airlines, Afghan airline, Kabul flights, Boeing 737-500, Airbus A310, Central Asia routes, flights from Uzbekistan",
    georgianAirwaysInfo:
      "Georgian Airways, Tashkent–Tbilisi, Embraer 190, Boeing 737-700, Georgia airline, European connections, South Caucasus travel",
    myWayAirlinesInfo:
      "MyWay Airlines, Georgia airline, Tbilisi flights, Boeing 737, charter flights Tashkent, Samarkand, CIS connections, low-cost airline",
    koreanAirInfo:
      "Korean Air, Tashkent–Seoul flights, Korean airline, SkyTeam, Airbus A330, Boeing 777, A380, Uzbekistan–Korea, premium airline",
    jazeeraAirwaysInfo:
      "Jazeera Airways, Kuwait airline, Tashkent–Kuwait flights, A320neo, budget carrier Gulf, Middle East flights, Uzbekistan travel",
    mahanAirInfo:
      "Mahan Air, Iran airline, Tashkent–Tehran flights, Airbus A310, A340, BAe 146, long-haul routes, Mahan Uzbekistan",
    indigoAirlinesInfo:
      "IndiGo Airlines, India airline, Tashkent–Delhi flights, A320neo, ATR 72, budget travel India, Uzbekistan to India, low-cost airline",
    alrosaAirlinesInfo:
      "Alrosa Airlines, Yakutia airline, Siberian flights, Tu-154M, Boeing 737, An-24, regional Russia flights, charter services",
    turkmenistanAirlinesInfo:
      "Turkmenistan Airlines, Ashgabat flights, Tashkent–Ashgabat route, Boeing 737, Boeing 777, Central Asia airline, Turkmenistan carrier",
    saudiaAirlinesInfo:
      "Saudia Airlines, Saudi Arabian airline, Tashkent–Jeddah, Hajj flights, Umrah, Boeing 777, A330, Riyadh, Medina, SkyTeam",
    pegasusAirInfo:
      "Pegasus Airlines, low-cost carrier, Tashkent–Istanbul flights, Sabiha Gökçen, Airbus A320-200, Airbus A320neo, Airbus A321neo, Boeing 737-800, fare prices, baggage policy, budget airline Turkey",
  },
};

export default metaKeywords;
